// removed by extract-text-webpack-plugin
module.exports = {"modal":"app-components-receipt-transactions-TransactionDetailModal-__TransactionDetailModal___2RB5L","modal-body":"app-components-receipt-transactions-TransactionDetailModal-__TransactionDetailModal___3Gkmf"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/transactions/TransactionDetailModal/TransactionDetailModal.css
// module id = 2258
// module chunks = 0